
/**
 * @author Christian Teister
 * @since 25.02.2011
 *
 *         DO NOT CHANGE THIS CLASS
 *
 *         PSEUDO RANDOM NUMBER GENERATOR
 *
 * (c) Copyright by Goodgame Studios. All rights reserved.
 */

export class SimpleRandom {
    private seed: number = 0;

    constructor(seed: number) {
        this.seed = (seed ^ 0xDEECE66D);
    }

    private next(): number {
        let l2: number = this.seed;
        l2 = this.toInt32(l2, 16807) % 2147483647;
        l2 = (this.toInt32(l2, 14903917) + 11) % 2147483647;
        this.seed = l2;
        return this.seed;
    }

    /**
     * All numbers in JS are 64bit floating point values. To imitate the AS int() cast we need to use bitshift operators
     * to internally convert to int32 and compensate for precision loss if p gets bigger than the biggest safe Integer
     * (pow(2,53) - 1) by comparing with a smaller partial product.
     */
    public toInt32(num1, num2):number {
        let p:number = num1 * num2;
        let int32:number = p >> 0;
        //We only need to ensure precision up to pow(2,55), because numbers in this generator will never be bigger, so
        //using the last 8 bit is more than enough here. Precision can never be off more than 2 bits (=3). If it does we
        //are dealing with an overflow issue and have to compensate.
        let inc:number = (((num1 % 0xFF) * num2) % 0xFF) - (p % 0xFF);
        if(Math.abs(inc) > 3){
            inc = Math.sign(inc) * (Math.abs(inc) - 0xFF);
        }
        int32 += inc;
        return int32;
    }

    public nextInt(maxInt: number): number {
        return this.nextInt2() % maxInt;
    }

    public nextInt2(): number {
        return Math.abs(this.next());
    }
}

